export default __webpack_public_path__ + "static/media/legacy.8121c031.png";